// extracted by mini-css-extract-plugin
export default {"main":"Info_main__pHfCm","text":"Info_text__DtWNm","img":"Info_img__il-ZL"};